// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"106e8a80924d42990097","752":"9243f6bc1949527c95e1"}[chunkId] + ".css";
};